// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3liTW","col":"styles_col__TJrg3","fulfillmentStatus":"styles_fulfillmentStatus__1ugQ4","emailCol":"styles_emailCol__3KBKc"};